import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, Input, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { MatMenuTrigger } from '@angular/material/menu';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

import { User } from './user.types';
import { UserService } from './user.service';
import { LoginService } from 'src/app/services/login.service';
import { SubscriptionsService } from 'src/app/services/subscriptions.service';
import { Constant } from 'src/app/constant/constant';
import { CashRegisterService } from 'src/app/services/cash-register.service';
import { FSDocument, FSDocumentElement } from './fullscreen.types';
import { DOCUMENT } from '@angular/common';
import { ConfigService } from 'src/app/services/config.service';
import { Clipboard } from '@angular/cdk/clipboard'
import { environment } from 'src/environments/environment';
import { ReferralProductService } from 'src/app/services/referral-product.service';
import { AccountsService } from 'src/app/services/accounts.service';
import { EcryptServiceService } from 'src/app/core/auth/EcryptionService/ecrypt-service.service';
import { NotificationService } from 'src/app/services/notification.service';
import { MatTableDataSource } from '@angular/material/table';
import { getPageSize, ResourceAccess } from 'src/app/shared/utils/calsoft-validators';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CommonService } from 'src/app/services/common.service';
import { E } from '@angular/cdk/keycodes';
import { TourService } from 'src/app/modules/tour/services/tour.service';


@Component({
    selector: 'user',
    templateUrl: './user.component.html',
    styleUrls: ['./user.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs: 'user'
})
export class UserComponent implements OnInit, OnDestroy {

    sanitizedUrl: string = '';


    url = '';

    currentDate = Date.now();
    isOpen: boolean;
    @ViewChild('userNotificationTrigger') userNotificationTrigger: MatMenuTrigger;
    private _isFullscreen: boolean = false;
    usersList: any;
    profileId: number;
    username: string;
    private _fsDoc: FSDocument;
    private _fsDocEl: FSDocumentElement;
    @Input() opened = false;
    @Input() hideMenu: boolean = false;

    // Private
    private _unsubscribeAll: Subject<any>;
    private _user: User;
    data: Object;
    @Input() posEnabled: any;
    referralId: string;
    enableAddUser: boolean = false;
    text: string = 'Add New User';
    showadduser: boolean = false;
    notificationList: any[] = [];
    pageList: any;
    elements: any;
    pageSizeValue: number[];
    adminHeader: any;
    siteUrl: any;
    twoFactorEnabled: boolean | null = null;

    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private notificationService: NotificationService,
        private commonService: CommonService,
        public router: Router,
        private _router: Router,
        private snackBar: MatSnackBar,
        private loginService: LoginService,
        private cashRegisterService: CashRegisterService,
        private ecryptService: EcryptServiceService,
        private configService: ConfigService,
        @Inject(DOCUMENT) private _document: Document,
        private clipboard: Clipboard,
        private referralProductService: ReferralProductService,
        private accountService: AccountsService,
        private tourService: TourService,
        private subscriptionsService: SubscriptionsService
    ) {
        this._fsDoc = _document as FSDocument;
        // Set the private defaults
        this._unsubscribeAll = new Subject();
        this.url = this._router.url || '';
        this._router.events
            .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
            .subscribe(() => { this.url = this._router.url || ''; });

    }


    rfId: any = false;

    read: any = false;

    crmSettingsData: any;

    dialerType: any;

    ngOnInit(): void {
        this._fsDocEl = document.documentElement as FSDocumentElement;
        this.url = this._router.url;

        this.loginService.authenticatedUserSubject
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(username => {
                this.username = username;
                this._changeDetectorRef.markForCheck();
            });

        this.adminHeader = localStorage.getItem("adminHeader");

        this.getAccountData();

        this.getAllNotification();

        this.getResource();

        this.getReferralId();

        let userType: any | null = null;

        const encryptedUserSettings = localStorage.getItem('userSettingsData');

        if (encryptedUserSettings) {
            try {
                const decrypted = this.ecryptService.decryptionAES(encryptedUserSettings);
                const userSettings = JSON.parse(decrypted);
                userType = userSettings.userType;
            } catch (error) {
                console.error('Error decrypting or parsing userSettingsData:', error);
            }
        }

        if (!userType) {
            const encryptedSigninDetails = localStorage.getItem('signinDetails');
            if (encryptedSigninDetails) {
                try {
                    const decrypted = this.ecryptService.decryptionAES(encryptedSigninDetails);
                    const signinDetails = JSON.parse(decrypted);
                    userType = signinDetails.userType;
                    if (typeof signinDetails.twoFactorEnabled === 'boolean') {
                        this.twoFactorEnabled = signinDetails.twoFactorEnabled;
                    }
                } catch (error) {
                    console.error('Error decrypting or parsing signinDetails:', error);
                }
            }
        }

        this.loadTwoFactorStatus();



        if (userType != undefined) {

            if (userType == 'ADMIN') {
                this.showadduser = true;
            }

            if (userType == 'AFFILIATE') {
                this.showadduser = true;
            }

        }

        const encrypted = localStorage.getItem('crmSettingsData');
        if (encrypted) {
            try {
                const decrypted = this.ecryptService.decryptionAES(encrypted);
                this.crmSettingsData = JSON.parse(decrypted);
                this.dialerType = this.crmSettingsData.dialerType;
            } catch (err) {

            }
        }

    }
    public page: any = Constant.PAGE;
    public size: any = Constant.SIZE;
    sortParam: any = 'notificationId' + "," + Constant.Dsc;
    unreadCount = 0;
    selectedTab: string = 'all';
    loadingNotifications: boolean = false;
    totalNotifications: number = 0;

    gotogrid() {
        this._router.navigate(['/adminNotification']);
    }

    setTab(tab: string) {
        this.selectedTab = tab;
    }

    extractNotificationLeadInfo(data: any): { leadId: string | null; setId: string | null } {
        if (!data) return { leadId: null, setId: null };

        let leadId: string | null = null;
        let setId: string | null = null;

        if (typeof data === 'number' || (typeof data === 'string' && /^\d+$/.test(data.trim()))) {
            return { leadId: String(data).trim(), setId: null };
        }

        if (typeof data === 'object') {
            leadId = data.leadId || data.id || (Array.isArray(data.leadIds) ? data.leadIds[0] : null);
            setId = data.setId || null;
            return { leadId: leadId ? String(leadId) : null, setId: setId ? String(setId) : null };
        }

        if (typeof data === 'string') {
            const trimmed = data.trim();
            if (trimmed.startsWith('{') || trimmed.startsWith('[')) {
                try {
                    const parsed = JSON.parse(trimmed);
                    if (parsed) {
                        leadId = parsed.leadId || parsed.id || (Array.isArray(parsed.leadIds) ? parsed.leadIds[0] : null);
                        setId = parsed.setId || null;
                        if (leadId) {
                            return { leadId: String(leadId), setId: setId ? String(setId) : null };
                        }
                    }
                } catch (e) {}
            }

            const leadIdMatch = trimmed.match(/leadId[=\s:]+([0-9]+)/i) || trimmed.match(/leadIds[=\s:]+\[([0-9]+)/i);
            if (leadIdMatch) {
                leadId = leadIdMatch[1];
            }

            const setIdMatch = trimmed.match(/setId[=\s:]+([0-9]+)/i);
            if (setIdMatch) {
                setId = setIdMatch[1];
            }
        }

        return { leadId: leadId ? String(leadId) : null, setId: setId ? String(setId) : null };
    }

    openNotification(notification: any) {
        if (this.userNotificationTrigger) {
            this.userNotificationTrigger.closeMenu();
        }
        if (!notification) {
            return;
        }
        if (notification.isRead === 0) {
            this.toggleRead(notification);
        }
        if (notification) {
            const typeLower = (notification.type || '').toLowerCase();
            const messageLower = (notification.message || '').toLowerCase();

            if (typeLower.includes('bulk lead transfer') || messageLower.includes('bulk lead transfer')) {
                this.onClickOutside();
                return;
            }

            const { leadId, setId } = this.extractNotificationLeadInfo(notification.data);

            if (typeLower === 'mention' || typeLower === 'duplicate lead' || typeLower === 'lead transfer' || typeLower.includes('lead') || typeLower.includes('transfer')) {
                if (leadId && /^\d+$/.test(leadId)) {
                    if (setId) {
                        this._router.navigate([`add-edit-leadDetail/${leadId}/${setId}`]);
                    } else {
                        this._router.navigate([`leadDetail/${leadId}`]);
                    }
                }
            }
        }
        this.onClickOutside();
    }

    /** Load notifications for page; append when requested */
    loadNotifications(page: number = 0, append: boolean = false) {
        if (this.loadingNotifications) return;
        this.loadingNotifications = true;

        this.notificationService.getAllNotificationNew(page, 10, this.sortParam).subscribe(
            (res: any) => {
                const items = res && res['content'] ? res['content'] : [];
                if (append) {
                    this.notificationList = [...(this.notificationList || []), ...items];
                } else {
                    this.notificationList = items;
                }

                this.elements = res['numberOfElements'];
                this.pageList = res['totalElements'];
                this.totalNotifications = this.pageList || 0;
                this.page = page;
                this.loadingNotifications = false;
                if (!append) {
                    this.updateUnreadCount();
                } else {
                    this._changeDetectorRef.markForCheck();
                }
            },
            (error) => {
                this.loadingNotifications = false;
            }
        );
    }

    updateUnreadCount(): void {
        this.notificationService.searchNotificationAdvance("a.isRead:0", 0, 1, 'notificationId,desc', "").subscribe({
            next: (res: any) => {
                if (res && res.totalElements !== undefined) {
                    this.unreadCount = res.totalElements;
                    this._changeDetectorRef.markForCheck();
                }
            },
            error: (err: any) => {}
        });
    }

    onNotificationsScroll(evt: any) {
        try {
            const target = evt.target as HTMLElement;
            const threshold = 120; // px from bottom to trigger
            if (this.loadingNotifications) return;
            if (!this.notificationList) return;

            const distanceFromBottom = target.scrollHeight - target.scrollTop - target.clientHeight;
            if (distanceFromBottom <= threshold) {
                const loaded = this.notificationList.length || 0;
                if (loaded < (this.totalNotifications || 0)) {
                    this.loadNotifications(this.page + 1, true);
                }
            }
        } catch (err) {
            // ignore
        }
    }
    getResource() {
        this.commonService
            .getAllAccessForResource(ResourceAccess.NOTIFICATION)
            .subscribe((data: any) => {
                if (data.read) {

                    this.read = data.read;

                }
            });
    }

    getAllNotification() {
        this.page = 0;
        this.loadNotifications(0, false);
    }
    toggleRead(notification: any) {

        const originalState = notification.isRead;
        notification.isRead = notification.isRead === 0 ? 1 : 0;
        this.updateUnreadCount();
        this.notificationService.addOrEditNotification(notification).subscribe({
            next: () => {
                this.updateUnreadCount();
                console.log('Notification status updated successfully');
            },
            error: (err) => {

                console.error('Failed to update notification:', err);
                notification.isRead = originalState;
                this.updateUnreadCount();


                this.snackBar.open('Failed to update notification status', 'Dismiss', {
                    duration: 3000
                });
            }
        });
    }

    markAllAsRead() {
        // this.notificationService.markAllAsRead().subscribe(() => {
        //   this.notificationList.forEach(n => n.isRead = 1);
        //   this.unreadCount = 0;
        // });
    }





    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
        this._onDestroy.next();
        this._onDestroy.complete();
    }


    /**
     * Sign out
     */
    signOut(): void {
        this._router.navigate(['/sign-out']);
        this.onClickOutside();
    }

    ngAfterViewInit() {
    }

    toggleDropdown() {
        this.isOpen = !this.isOpen;
    }

    onClickOutside() {
        this.isOpen = false;
    }


    profile() {
        this._router.navigate([`/userRole/profile`])
        this.onClickOutside();
    }

    openTwoFactorAuth(): void {
        this._router.navigate(['/two_factor_auth']);
        this.onClickOutside();
    }

    billing(): void {
        this._router.navigate(['/subscription/manage']);
        this.onClickOutside();
    }

    private loadTwoFactorStatus(): void {
        this.loginService.getTwoFactorStatus().subscribe(
            (response: any) => {
                if (response && response['status_code'] === 'AST-200' && response['data']) {
                    this.twoFactorEnabled = !!response['data'].twoFactorEnabled;
                    const encryptedSigninDetails = localStorage.getItem('signinDetails');
                    if (encryptedSigninDetails) {
                        try {
                            const decrypted = this.ecryptService.decryptionAES(encryptedSigninDetails);
                            const signinDetails = JSON.parse(decrypted);
                            signinDetails.twoFactorEnabled = this.twoFactorEnabled;
                            localStorage.setItem('signinDetails', this.ecryptService.encryptionAES(JSON.stringify(signinDetails)));
                        } catch (error) {
                            console.error('Error updating two-factor state in signinDetails:', error);
                        }
                    }
                    this._changeDetectorRef.markForCheck();
                }
            },
            () => {
                // Keep last known state if status fetch fails.
            }
        );
    }

    gotoPos() {

        this._router.navigate(['/pos/sale']);

        // this.cashRegisterService.checkCashRegisterActive().subscribe(
        //     (response) => {


        //         if (!response) {
        //             this._router.navigate(['/pos/cashRegister']);
        //         } else {
        //             this._router.navigate(['/pos/sale']);
        //         }


        //     },
        //     (error) => { }
        // );

        this.onClickOutside();
    }

    handleQuantityAlert() {
        this._router.navigate(['/productQuantityAlerts']);
    }

    handleExpiryAlert() {
        this._router.navigate(['/productExpiryAlerts']);
    }

    /**
      * Toggle the fullscreen mode
      */
    toggleFullscreen(): void {
        // Check if the fullscreen is open
        this._isFullscreen = this._getBrowserFullscreenElement() !== null;

        // Toggle the fullscreen
        if (this._isFullscreen) {
            this._closeFullscreen();
        }
        else {
            this._openFullscreen();
        }
    }


    // -----------------------------------------------------------------------------------------------------
    // @ Private methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get browser's fullscreen element
     *
     * @private
     */
    private _getBrowserFullscreenElement(): Element {
        if (typeof this._fsDoc.fullscreenElement !== 'undefined') {
            return this._fsDoc.fullscreenElement;
        }

        if (typeof this._fsDoc.mozFullScreenElement !== 'undefined') {
            return this._fsDoc.mozFullScreenElement;
        }

        if (typeof this._fsDoc.msFullscreenElement !== 'undefined') {
            return this._fsDoc.msFullscreenElement;
        }

        if (typeof this._fsDoc.webkitFullscreenElement !== 'undefined') {
            return this._fsDoc.webkitFullscreenElement;
        }

        throw new Error('Fullscreen mode is not supported by this browser');
    }


    /**
* Open the fullscreen
*
* @private
*/
    private _openFullscreen(): void {
        if (this._fsDocEl.requestFullscreen) {
            this._fsDocEl.requestFullscreen();
            return;
        }

        // Firefox
        if (this._fsDocEl.mozRequestFullScreen) {
            this._fsDocEl.mozRequestFullScreen();
            return;
        }

        // Chrome, Safari and Opera
        if (this._fsDocEl.webkitRequestFullscreen) {
            this._fsDocEl.webkitRequestFullscreen();
            return;
        }

        // IE/Edge
        if (this._fsDocEl.msRequestFullscreen) {
            this._fsDocEl.msRequestFullscreen();
            return;
        }
    }

    /**
     * Close the fullscreen
     *
     * @private
     */
    private _closeFullscreen(): void {
        if (this._fsDoc.exitFullscreen) {
            this._fsDoc.exitFullscreen();
            return;
        }

        // Firefox
        if (this._fsDoc.mozCancelFullScreen) {
            this._fsDoc.mozCancelFullScreen();
            return;
        }

        // Chrome, Safari and Opera
        if (this._fsDoc.webkitExitFullscreen) {
            this._fsDoc.webkitExitFullscreen();
            return;
        }

        // IE/Edge
        else if (this._fsDoc.msExitFullscreen) {
            this._fsDoc.msExitFullscreen();
            return;
        }
    }



    copyInputUrl() {

        this.adminHeader = localStorage.getItem("adminHeader");

        if (this.adminHeader == 1) {
            let urlNew = environment.serverAPI;
            const baseUrl = urlNew.split('/ecom-gateway/')[0];
            let url = baseUrl + "/register" + "?refId=" + this.referralId;
            this.clipboard.copy(`${url}`);

        } else {
            //let url = this.siteUrl + "/home" + "?refId=" + this.referralId;

            let url = this.siteUrl + "?refId=" + this.referralId

            this.clipboard.copy(`${url}`);
            this.snackBar.open(`Copied`, '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
        }



    }



    getReferralId() {
        this.referralProductService.getReferalId().subscribe(
            res => {


                if (res['data'] != null) {
                    this.siteUrl = res['data']['siteUrl'];
                    this.referralId = res['data']['id'];
                    this.rfId = true;

                }


            },
            error => {

            }
        )
    }

    accountList: any = [];

    displayRenewButton: any = false;
    getAccountData() {
        this.accountService.getAllAccountsBYtenant().subscribe(
            (data: any) => {


                this.accountList = data;

                if (this.accountList.length > 0) {
                    const acc = this.accountList[0];
                    const message = this.subscriptionsService.getSubscriptionMessage(acc);
                    this.subscriptionsService.updateTrialExpiredMessage(message);

                    console.log("accountList", this.accountList);

                    if (this.accountList[0].accountName == 'calsoft') {
                        localStorage.setItem('displayedTour', 'true');
                    } else {
                        localStorage.setItem('displayedTour', 'false');
                    }

                    localStorage.setItem('accountPlan', this.accountList[0].plan);

                    localStorage.setItem('businessDetailProvide', this.accountList[0].businessDetailProvide);

                    localStorage.setItem('businessType', this.accountList[0].businessType);

                    let user = this.accountList[0].totalUserSubscrition;

                    let renewalDate = this.accountList[0].renewalDate;

                    let today = new Date();


                    if (this.accountList[0].freeTrail == 1) {

                        this.text = 'Upgrade'

                        if (this.showadduser == true) {
                            this.displayRenewButton = true;
                        }
                        this.enableAddUser = true;

                    } else {

                        this.text = 'Add New User';
                        if (!renewalDate) {
                            renewalDate = today.toISOString(); // or format it as needed
                            console.log('Renewal date was null. Set to today:', renewalDate);
                        }

                        // Convert renewalDate string to Date object
                        let renewalDateObj = new Date(renewalDate);

                        // Get the difference in time (milliseconds)
                        let diffTime = renewalDateObj.getTime() - today.getTime();

                        // Convert to number of days
                        let diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

                        if (diffDays > 7) {

                            this.enableAddUser = true;


                        } else {
                            this.enableAddUser = false;
                        }
                        if (this.showadduser == true) {
                            this.displayRenewButton = true;
                        }
                    }

                    this._changeDetectorRef.detectChanges();

                }

            }




        )
    }

    new() {

        this._router.navigate(['/subscription/checkout']);

    }


    renew() {

        this._router.navigate(['/renewal']);

    }

    navigateto() {
        const userId = localStorage.getItem('userId');
        const companyId = localStorage.getItem('storeName');

        const baseUrl = "https://client5.rekzyl.com/settings/channels";
        const params = new URLSearchParams({
            leftServiceId: "93eeb600-dcb1-4382-bf11-846c467deb79",
            service: "calsoft",
            userId: userId,
            companyId: companyId
        });

        const url = `${baseUrl}?${params.toString()}`;
        //window.location.href = url; 

        window.open(url, '_blank');
    }




    sanitizeUrl(u: string): string {
        return (u || '')
            .replace(/^\/+/, '')
            .replace(/[?#&=]/g, '-')
            .replace(/[^a-zA-Z0-9_-]+/g, '-')
            .replace(/-+/g, '-')
            .replace(/^-|-$/g, '')
            .toLowerCase();
    }

    protected _onDestroy = new Subject<void>();

    startTour(): void {
        this.onClickOutside();
        this.tourService.startTour();
    }

}
